import { defineStore } from "pinia";
const selectStore = defineStore("select", {
  state: () => {
    return { activeClass: true, activeClass2: true, activeClass3: true };
  },
  actions: {
    activeClassFunction(activeClass: boolean) {
      this.activeClass = activeClass;
    },
    activeClassFunction2(activeClass2: boolean) {
      this.activeClass2 = activeClass2;
    },
    activeClassFunction3(activeClass3: boolean) {
      this.activeClass3 = activeClass3;
    },
  },
});

export default selectStore;
